var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"networkStatus"},[_c('div',{class:[_vm.status.bool ? 'networkStatus__icon--online' : 'networkStatus__icon--offline', 'networkStatus__icon']}),_c('div',{staticClass:"networkStatus__label"},[_vm._v(_vm._s(_vm.status.val))])])
}
var staticRenderFns = []

export { render, staticRenderFns }